import request from '@/utils/request'

export function getList (filters = {}, pagination = {}) {
  return request({
    url: '/pregnancy_has_treatment',
    method: 'get',
    headers: {
      'X-filters': JSON.stringify(filters),
      'X-pagination': JSON.stringify(pagination)
    }
  })
}

export function getDetail (data) {
  return request({
    url: '/pregnancy_has_treatment/' + data.pregnancy_id + '/' + data.treatment_id,
    method: 'get'
  })
}

export function upsert (data) {
  var method = 'post'
  var url = '/pregnancy_has_treatment'
  if (data.id) {
    method = 'put'
    url = '/pregnancy_has_treatment/' + data.pregnancy_id + '/' + data.treatment_id
  }
  return request({
    url,
    method,
    data
  })
}

export function remove (data) {
  return request({
    url: '/pregnancy_has_treatment/' + data.pregnancy_id + '/' + data.treatment_id,
    method: 'delete'
  })
}
